export { ProtectedEventGate } from './ProtectedEventGate';
export type { ProtectedEventGateProps } from './ProtectedEventGate';
